import styled from 'styled-components/macro';
import { baseSpacing, colors, transition } from 'css/constants';
import { lighten } from 'polished';

export const Steps = styled.ul`
  display: flex;
  list-style: none;
  margin: 0 0 ${baseSpacing / 2}px;
  padding: 0;
`;

export const Step = styled.li`
  display: flex;
  justify-content: center;
  flex-basis: 50%;
  position: relative;
  padding-bottom: ${baseSpacing * 1.33}px;
  transition: ${transition};

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: ${baseSpacing / 2}px;
    transform: translateY(50%);
    width: 50%;
    height: ${baseSpacing / 6}px;
    background: ${({ isComplete }) =>
      isComplete ? lighten(0.2, colors.blue) : colors.lightGrey};
  }

  &::after {
    right: 0;
  }

  &::before {
    left: 0;
    background: ${({ isActive }) => isActive && lighten(0.2, colors.blue)};
  }

  &:first-child::before,
  &:last-child::after {
    display: none;
  }
`;

export const StepNumber = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${baseSpacing * 1.2}px;
  height: ${baseSpacing * 1.2}px;
  border-radius: 100%;
  ${({ isActive, isComplete }) =>
    isActive || isComplete
      ? `
      background: ${colors.blue};
      color: #fff;
    `
      : `
    background: ${colors.lightGrey};
    `}
  border: 1px solid rgb(0 0 0 / 10%);
  text-align: center;
  z-index: 1;
  transition: ${transition};
  box-shadow: ${({ isActive }) =>
    isActive && `0 0 0 ${baseSpacing / 4}px ${lighten(0.3, colors.blue)}`};
`;

export const StepName = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  transition: ${transition};
  color: ${({ isActive }) => (isActive ? colors.blue : 'inherit')};
`;
